module.exports = __webpack_public_path__ + "img/ducks.48622fbd.png";